/** Explicit acceptance is required before exposing a map through a public link. */
export const SHARING_RULES_VERSION = '2026-09-30.1';
export const REPORT_REASONS = [
    'nudity',
    'violence',
    'harassment',
    'illegal',
    'privacy',
    'spam',
    'other',
];
export const SHARING_RULES = {
    en: 'Shared maps must not contain nudity, sexual content, violent imagery, threats, encouragement of violence, abuse, hate, illegal material or personal information disclosed without permission. Anyone with the link can view the map. Reports are reviewed and sharing may be suspended.',
    pt: 'Mapas compartilhados não podem conter nudez, conteúdo sexual, imagens de violência, ameaças, incentivo à violência, abuso, ódio, material ilegal ou dados pessoais divulgados sem autorização. Qualquer pessoa com o link pode ver o mapa. Denúncias serão analisadas e o compartilhamento poderá ser suspenso.',
};
export const REPORT_LABELS = {
    nudity: ['Nudity or sexual content', 'Nudez ou conteúdo sexual'],
    violence: ['Violence or threats', 'Violência ou ameaças'],
    harassment: ['Harassment or hate', 'Assédio ou ódio'],
    illegal: ['Illegal content', 'Conteúdo ilegal'],
    privacy: ['Personal information', 'Dados pessoais'],
    spam: ['Spam or fraud', 'Spam ou fraude'],
    other: ['Other', 'Outro'],
};
//# sourceMappingURL=sharing-policy.js.map